<template>
  <router-view />
</template>

<script>
import emitter, { setDeviceStatus } from "@/utils/eventBus";
import { customers } from "@/utils/userInfo.js";

let socket = null;

export default {
  data() {
    return {
      reconnect: true,
      reconnectAttempts: 0,
      lastSeenTimestamps: {},
      deviceStatuses: {},
    };
  },

  methods: {
    initWebSocket() {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.close();
      }

      socket = new WebSocket(this.API_WS);

      socket.onopen = () => this.onOpenWS();
      socket.onmessage = (event) => this.onMessage(event);
      socket.onclose = () => this.onWSClose();
    },

    onOpenWS() {
      this.$store.commit("setConnected", true);

      customers.forEach((customer) => {
        const sendMsg = (token) => {
          const msg = JSON.stringify({
            deviceToken: token,
            state: true,
            data: true,
          });
          socket.send(msg);
        };

        sendMsg(customer.token);
        if (customer.solar) sendMsg(customer.solar);
        if (customer.battery) sendMsg(customer.battery);
      });
    },

    onMessage(event) {
      try {
        const wsMessage = JSON.parse(event.data);
        const device = wsMessage.device.replace(/-/g, "");
        const now = Date.now();

        this.lastSeenTimestamps[device] = now;

        if (wsMessage.topic === "Data") {
          this.$set(this.deviceStatuses, device, true);
          emitter.emit("device-status", { device, isOnline: true });
          setDeviceStatus(device, true);
          emitter.emit("update-values", { wsMessage, device });
        }
      } catch (err) {}
    },

    onWSClose() {
      this.$store.commit("setConnected", false);

      customers.forEach((customer) => {
        const device = customer.token.split("|")[0];
        emitter.emit("device-status", { device, isOnline: false });
        setDeviceStatus(device, false);
      });

      if (this.reconnect) {
        setTimeout(() => {
          this.reconnectAttempts++;
          this.initWebSocket();
        }, 5000);
      }
    },

    checkDeviceStatuses() {
      const now = Date.now();
      const timeout = 3000;

      customers.forEach((customer) => {
        const device = customer.token.split("|")[0].replace(/-/g, "");
        const lastSeen = this.lastSeenTimestamps[device];
        const isOnline = lastSeen && now - lastSeen < timeout;

        if (this.deviceStatuses[device] !== isOnline) {
          setDeviceStatus(device, isOnline);
          this.$set(this.deviceStatuses, device, isOnline);
          emitter.emit("device-status", { device, isOnline });
        }
      });
    },
  },

  mounted() {
    this.initWebSocket();

    this.deviceStatusInterval = setInterval(() => {
      this.checkDeviceStatuses();
    }, 1000);
  },

  beforeDestroy() {
    this.reconnect = false;
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.close();
    }
    clearInterval(this.deviceStatusInterval);
    this.$store.commit("setConnected", false);
  },
};
</script>
